(function () {
  const PDFJS_VERSION = "4.4.168";

  const PDFJS_URL =
    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/" +
    PDFJS_VERSION +
    "/pdf.min.mjs";

  const PDFJS_WORKER_URL =
    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/" +
    PDFJS_VERSION +
    "/pdf.worker.min.mjs";

  async function initCatalogue(container) {
    if (
      !container ||
      container.dataset.initialized === "true"
    ) {
      return;
    }

    container.dataset.initialized = "true";

    const pdfUrl =
      container.dataset.pdfUrl;

    const viewer =
      container.querySelector(
        ".exhibition-catalogue__viewer"
      );

    const book =
      container.querySelector(
        ".exhibition-catalogue__book"
      );

    const pageContainer =
      container.querySelector(
        ".exhibition-catalogue__page--right"
      );

    const canvas =
      pageContainer.querySelector(
        "canvas"
      );

    const leftPage =
      container.querySelector(
        ".exhibition-catalogue__page--left"
      );

    const currentEl =
      container.querySelector(
        "[data-current]"
      );

    const totalEl =
      container.querySelector(
        "[data-total]"
      );

    const previousButtons =
      container.querySelectorAll(
        '[data-action="previous"], .exhibition-catalogue__arrow--left'
      );

    const nextButtons =
      container.querySelectorAll(
        '[data-action="next"], .exhibition-catalogue__arrow--right'
      );

    const fullscreenButton =
      container.querySelector(
        '[data-action="fullscreen"]'
      );

    let pdf = null;
    let currentPage = 1;

    /*
     * Render internally at higher resolution
     * for sharper text and images.
     */
    const pixelRatio = Math.min(
      window.devicePixelRatio || 1,
      2.5
    );

    async function loadPdfJs() {
      const pdfjsLib =
        await import(PDFJS_URL);

      pdfjsLib.GlobalWorkerOptions.workerSrc =
        PDFJS_WORKER_URL;

      return pdfjsLib;
    }

    async function renderPage(pageNumber) {
      if (!pdf || !canvas) {
        return;
      }

      pageNumber = Math.max(
        1,
        Math.min(
          pageNumber,
          pdf.numPages
        )
      );

      currentPage = pageNumber;

      /*
       * Get the page we're displaying.
       */
      const page =
        await pdf.getPage(
          pageNumber
        );

      /*
       * PAGE 2 is used as the reference
       * size because it is the first
       * landscape double-page spread.
       *
       * The cover remains portrait,
       * but sits inside the same overall
       * catalogue frame.
       */
      const referencePage =
        pdf.numPages >= 2
          ? await pdf.getPage(2)
          : page;

      const referenceViewport =
        referencePage.getViewport({
          scale: 1
        });

      /*
       * Calculate the actual width available
       * inside the viewer after CSS padding.
       */
      const viewerWidth =
        viewer.clientWidth;

      const viewerStyles =
        window.getComputedStyle(
          viewer
        );

      const horizontalPadding =
        parseFloat(
          viewerStyles.paddingLeft || 0
        ) +
        parseFloat(
          viewerStyles.paddingRight || 0
        );

      const availableWidth =
        Math.max(
          280,
          viewerWidth -
            horizontalPadding
        );

      /*
       * Use the landscape spread width
       * as the catalogue width.
       */
      const displayScale =
        availableWidth /
        referenceViewport.width;

      /*
       * Render internally at higher
       * resolution for better quality.
       */
      const renderScale =
        displayScale *
        pixelRatio;

      const renderViewport =
        page.getViewport({
          scale: renderScale
        });

      const displayViewport =
        page.getViewport({
          scale: displayScale
        });

      /*
       * High-resolution canvas dimensions.
       */
      canvas.width =
        Math.ceil(
          renderViewport.width
        );

      canvas.height =
        Math.ceil(
          renderViewport.height
        );

      /*
       * CSS/display dimensions.
       */
      canvas.style.width =
        Math.ceil(
          displayViewport.width
        ) + "px";

      canvas.style.height =
        Math.ceil(
          displayViewport.height
        ) + "px";

      canvas.style.maxWidth =
        "100%";

      canvas.style.display =
        "block";

      /*
       * The landscape spread establishes
       * the overall frame height.
       */
      const referenceDisplayHeight =
        referenceViewport.height *
        displayScale;

      /*
       * The page itself keeps its natural
       * aspect ratio.
       */
      pageContainer.style.width =
        Math.ceil(
          displayViewport.width
        ) + "px";

      pageContainer.style.height =
        Math.ceil(
          referenceDisplayHeight
        ) + "px";

      pageContainer.style.maxWidth =
        "100%";

      pageContainer.style.display =
        "flex";

      pageContainer.style.alignItems =
        "center";

      pageContainer.style.justifyContent =
        "center";

      /*
       * Render the PDF page.
       */
      const context =
        canvas.getContext(
          "2d",
          {
            alpha: false
          }
        );

      context.imageSmoothingEnabled =
        true;

      context.imageSmoothingQuality =
        "high";

      await page.render({
        canvasContext: context,
        viewport: renderViewport
      }).promise;

      /*
       * Page counter.
       */
      if (currentEl) {
        currentEl.textContent =
          currentPage;
      }

      if (totalEl) {
        totalEl.textContent =
          pdf.numPages;
      }

      updateButtons();
    }

    function updateButtons() {
      if (!pdf) {
        return;
      }

      previousButtons.forEach(
        function (button) {
          button.disabled =
            currentPage <= 1;
        }
      );

      nextButtons.forEach(
        function (button) {
          button.disabled =
            currentPage >=
            pdf.numPages;
        }
      );
    }

    function nextPage() {
      if (
        !pdf ||
        currentPage >=
          pdf.numPages
      ) {
        return;
      }

      renderPage(
        currentPage + 1
      );
    }

    function previousPage() {
      if (
        !pdf ||
        currentPage <= 1
      ) {
        return;
      }

      renderPage(
        currentPage - 1
      );
    }

    /*
     * Previous buttons.
     */
    previousButtons.forEach(
      function (button) {
        button.addEventListener(
          "click",
          previousPage
        );
      }
    );

    /*
     * Next buttons.
     */
    nextButtons.forEach(
      function (button) {
        button.addEventListener(
          "click",
          nextPage
        );
      }
    );

    /*
     * Fullscreen.
     */
    /*
 * Fullscreen.
 *
 * Use a CSS-based fullscreen mode rather
 * than the browser's native fullscreen API.
 * This behaves much more consistently on
 * desktop and mobile browsers.
 */
if (fullscreenButton) {
  fullscreenButton.addEventListener(
    "click",
    function () {
      container.classList.toggle(
        "exhibition-catalogue--fullscreen"
      );

      fullscreenButton.textContent =
        container.classList.contains(
          "exhibition-catalogue--fullscreen"
        )
          ? "Exit fullscreen"
          : "Fullscreen";

      /*
       * Give the browser a moment to apply
       * the fullscreen layout, then render
       * the current page at the new size.
       */
      setTimeout(function () {
        if (pdf) {
          renderPage(currentPage);
        }
      }, 50);
    }
  );
}

    /*
     * Keyboard navigation.
     */
    document.addEventListener(
      "keydown",
      function (event) {
        const tag =
          document.activeElement
            ? document.activeElement
                .tagName
            : "";

        if (
          tag === "INPUT" ||
          tag === "TEXTAREA" ||
          tag === "SELECT"
        ) {
          return;
        }

        if (
          event.key ===
          "ArrowRight"
        ) {
          nextPage();
        }

        if (
          event.key ===
          "ArrowLeft"
        ) {
          previousPage();
        }
      }
    );

    /*
     * Re-render after resizing.
     */
    let resizeTimer;

    window.addEventListener(
      "resize",
      function () {
        clearTimeout(
          resizeTimer
        );

        resizeTimer =
          setTimeout(
            function () {
              if (pdf) {
                renderPage(
                  currentPage
                );
              }
            },
            200
          );
      }
    );

    try {
      /*
       * Load PDF.js.
       */
      const pdfjsLib =
        await loadPdfJs();

      /*
       * Load the PDF.
       */
      pdf =
        await pdfjsLib
          .getDocument({
            url: pdfUrl
          })
          .promise;

      /*
       * Hide the unused left page.
       */
      if (leftPage) {
        leftPage.style.display =
          "none";
      }

      /*
       * Centre the single PDF page.
       */
      if (book) {
        book.style.display =
          "flex";

        book.style.width =
          "100%";

        book.style.alignItems =
          "center";

        book.style.justifyContent =
          "center";
      }

      /*
       * Start on the cover.
       */
      await renderPage(1);
      pageContainer.classList.add("is-loaded");

if (loading) {
  loading.classList.add(
    "exhibition-catalogue__loading--hidden"
  );
}

    } catch (error) {
      console.error(
        "Exhibition catalogue failed to load:",
        error
      );

      container.classList.add(
        "exhibition-catalogue--error"
      );
    }
  }

  function initAll() {
    document
      .querySelectorAll(
        ".exhibition-catalogue"
      )
      .forEach(
        initCatalogue
      );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initAll
    );
  } else {
    initAll();
  }
})();
